/* eslint-disable no-restricted-imports */
import React, { useEffect, useState, useCallback } from "react";
import {
  InputLabel,
  Button,
  RadioGroup,
  Radio,
  Checkbox,
  FormControlLabel
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Toast, Col, Row } from "react-bootstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { ToastContainer, toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import { toAbsoluteUrl } from "../../_metronic/_helpers";
import { OrgList } from "./OrgList";
import { AccountEdit } from "./AccountEdit";
import {
  deleteAccountInfoData,
  getUserListData
} from "../modules/Auth/_redux/adminCrud";

export function AllAccountPage() {
  const useStyles = makeStyles(theme => ({
    treeContainerStyle: {
      display: "inline-block",
      width: "calc(20% - 12px)",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px",
      marginRight: "12px",
      verticalAlign: "top"
    },
    listContainerStyle: {
      display: "inline-block",
      width: "80%",
      border: "1px solid #c8cace",
      borderRadius: "4px 4px 4px 4px"
    },
    inputStyle: {
      display: "inline-flex",
      width: "200px",
      height: "32px",
      border: "1px solid #c8cace",
      paddingLeft: "8px",
      borderRadius: "2px 2px 2px 2px",
      ":active": {
        border: "1px solid #c8cace"
      }
    },
    buttonStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1.2rem",
      marginRight: "12px"
    },
    buttonSmallStyle: {
      width: "60px",
      height: "28px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem"
      //   marginLeft: "12px"
    },

    buttonDisableStyle: {
      color: "#b4b5b8",
      border: "1px solid #b4b5b8",
      background: "#ebedf1"
    },
    buttonClearStyle: {
      width: "32px",
      height: "32px",
      border: "0px solid #123456",
      marginRight: "12px",
      "&:hover": {
        backgroundColor: "transparent !important"
      }
    },
    searchStyle: {
      width: "120px",
      height: "32px",
      color: "#123456",
      border: "1px solid #123456",
      fontSize: "1rem",
      float: "right"
    },
    dateStyle: {
      width: "160px",
      height: "32px",
      color: "#123456",
      border: "1px solid #c8cace",
      fontSize: "1rem",
      marginRight: "36px",
      textAlign: "left",
      background: "transparent",
      borderRadius: "4px 4px 4px 4px",
      paddingLeft: "12px"
    },

    boxContainer: {
      display: "inline-block",
      width: "100%",
      verticalAlign: "top"
    },
    box30Style: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    boxStyle: {
      width: "100%",
      display: "inline-block",
      background: "white",
      border: "1px solid lightgray",
      padding: "24px",
      marginBottom: "12px"
    },
    subTitleStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      marginBottom: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    subTitleInnerStyle: {
      display: "block",
      fontSize: "1rem",
      width: "100%",
      margin: "12px",
      fontWeight: "bold",
      alignItems: "baseline",
      color: "#555555"
    },
    headerRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px"
    },
    headerColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      fontWeight: "bold",
      textAlign: "center",
      width: "50%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      background: "#dfe2e8",
      height: "44px"
    },
    headerCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      background: "#dfe2e8",
      height: "44px"
    },
    dataCheckboxStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "44px",
      //   background: "#dfe2e8",
      height: "44px"
    },
    dataRowStyle: {
      display: "flex",
      textAlign: "center",
      height: "44px",
      lineHeight: "44px",
      borderBottom: "1px solid lightgray"
    },
    width100Style: {
      width: "100%"
    },
    dataColStyle: {
      display: "inline-block",
      fontSize: "1rem",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "auto",
      textOverflow: "ellipsis"
    },
    dataCol100Style: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "center",
      width: "100%",
      height: "44px"
    },
    dataColSmallStyle: {
      display: "inline-block",
      fontSize: "12px",
      textAlign: "center",
      width: "50%",
      height: "44px",
      overflow: "hidden",
      lineHeight: "16px",
      paddingTop: "6px"
    },
    dataColTextStyle: {
      display: "inline-block",
      fontSize: "1.143rem",
      textAlign: "left",
      //   width: "50%",
      height: "44px"
    },
    radioStyle: {
      width: "80px",
      fontSize: "1rem",
      //   background: "transparent",
      color: "#555555",
      borderColor: "#dfe2e8",
      "&:active": {
        color: "white",
        backgroundColor: "#123456 !important"
      }
    },
    selected: {
      color: "white",
      backgroundColor: "#123456 !important"
    }
  }));

  const [userList, setUserList] = useState([]);

  const Styles = useStyles();
  const [refresh, setRefresh] = React.useState(false);
  const [showAsk, setShowAsk] = React.useState(false);
  const [showAskMove, setShowAskMove] = React.useState(false);
  const [showNew, setShowNew] = React.useState(false);
  const [showToast, setShowToast] = React.useState(false);
  const [editTitle, setEditTitle] = React.useState("");
  const [editIP, setEditIP] = React.useState("");
  const [editDesc, setEditDesc] = React.useState("");
  const [deptName, setDeptName] = React.useState(" ");
  const [deptUserCount, setDeptUserCount] = React.useState("(0명)");
  const [showAccount, setShowAccount] = React.useState(false);
  const [allChecked, setAllChecked] = React.useState(false);
  const [editMode, setEditMode] = React.useState("NEW");
  const [editUserData, setEditUserData] = React.useState();
  const [selectedDept, setSelectedDept] = React.useState();

  const [showOrgList, setShowOrgList] = React.useState(false);
  const [tempDeptName, setTempDeptName] = React.useState("");
  const [searchName, setSearchName] = React.useState("");

  const formatBytes = (bytes = 0, fixed) => {
    const marker = 1024; // Change to 1000 if required
    const decimal = fixed != null ? fixed : 2; // Change as required
    const kiloBytes = marker; // One Kilobyte is 1024 bytes
    const megaBytes = marker * marker; // One MB is 1024 KB
    const gigaBytes = marker * marker * marker; // One GB is 1024 MB
    // const teraBytes = marker * marker * marker * marker; // One TB is 1024 GB

    // return bytes if less than a KB
    if (bytes == null || bytes < kiloBytes) {
      return `${bytes}B`;
      // return KB if less than a MB
    }
    if (bytes < megaBytes) {
      return `${(bytes / kiloBytes).toFixed(decimal)}KB`;
      // return MB if less than a GB
    }
    if (bytes < gigaBytes) {
      return `${(bytes / megaBytes).toFixed(decimal)}MB`;
      // return GB if less than a TB
    }

    return `${(bytes / gigaBytes).toFixed(decimal)}GB`;
  };

  const checkIpAddress = () => {
    return true;
  };

  const processPressDelete = () => {
    const zimbraIds = userList
      .filter(user => user.checked)
      .map(user => user.zimbraId)
      .join(",");

    const emailIds = userList
      .filter(user => user.checked)
      .map(user => user.email)
      .join(",");

    console.log("DELETE", emailIds, zimbraIds);

    deleteAccountInfoData(emailIds, zimbraIds).then(result => {
      if (result.code === 200) {
        setShowAsk(false);
        handleOrgDeptSelected(selectedDept);
      } else {
        toast("처리도중 에러가 발생했습니다.");
      }
    })
    .catch(error => {
      console.log(error)
    })

    setShowAsk(true);
  };

  const handleOrgOnInit = dept => {
    console.log("handleOrgOnInit", dept);

    setDeptName(dept.deptName);
    setRefresh(!refresh);
  };

  const handleUserEnrolled = dept => {
    console.log("handleUserEnrolled", dept);

    getUserListData(dept?.deptCode).then(data => {
      console.log("USERS", data);
      if (data.data.users != null) {
        data.data.users.map(user => {
          user.status = "활성";
          user.level = "사용자";
          user.checked = false;
          user.mailQuota = `${formatBytes(user.used)} / ${
            user.limit > 0 ? formatBytes(user.limit) : "무제한"
          }`;
          user.date = user.createDt.split("T")[0];
        });

        let users = data.data.users;
        if (searchName !== "")
          users = data.data.users.filter(
            user => user.name.indexOf(searchName) >= 0
          );

        console.log("FILTERED", users);

        setUserList(users);
        if (dept != null) setDeptName(dept.deptName);
        setDeptUserCount(`(${users.length}명)`);
        setRefresh(!refresh);
      }
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handleUserPartner = () => {
    console.log("handleUserPartner");

    getUserListData(null).then(data => {
      console.log("USERS", data);
      if (data.data.users != null) {
        data.data.users.map(user => {
          user.status = "활성";
          user.level = "사용자";
          user.checked = false;
          user.mailQuota = `${formatBytes(user.used)} / ${
            user.limit > 0 ? formatBytes(user.limit) : "무제한"
          }`;
          user.date = user.createDt.split("T")[0];
        });

        let users = data.data.users.filter(user => user.isAnonymous === "Y");

        if (searchName !== "")
          users = users.filter(user => user.name.indexOf(searchName) >= 0);

        console.log("FILTERED", users);

        setUserList(users);
        setDeptName("미분류");
        setDeptUserCount(`(${users.length}명)`);
        setRefresh(!refresh);
      }
    })
    .catch(error => {
      console.log(error)
    })
  };

  const handleOrgDeptSelected = dept => {
    console.log("handleOrgDeptSelected", dept);
    if (dept?.subList != null && dept?.subList.length > 0) return;

    setSelectedDept(dept);

    if (dept?.deptCode === 77777) handleUserPartner();
    else handleUserEnrolled(dept);
  };

  const handlePressSearch = () => {
    console.log("SEARCH", searchName);

    handleOrgDeptSelected(selectedDept);
  };

  const handlePressModifyAccount = user => {
    setEditMode("MODIFY");
    setEditUserData(user);
    setShowAccount(true);
  };

  const handlePressNewAccount = user => {
    setEditMode("NEW");
    // setEditUserData(user);
    setShowAccount(true);
  };

  useEffect(() => {}, [refresh, searchName]);

  useEffect(() => {
    handleOrgDeptSelected(null);
  }, []);

  return (
    <>
      <ToastContainer />
      <div
        style={{
          marginTop: "12px",
          marginLeft: "-12px",
          height: "100%"
        }}
      >
        {/* -------------------- */}

        <div className={Styles.boxContainer}>
          <div className={Styles.boxStyle}>
            <div className={Styles.subTitleStyle}>
              <Button className={Styles.buttonStyle} onClick={() => {}}>
                가져오기
              </Button>
              <Button className={Styles.buttonStyle} onClick={() => {}}>
                내보내기
              </Button>

              <div
                style={{
                  display: "inline-block",
                  float: "right"
                }}
              >
                <Button
                  className={Styles.buttonSmallStyle}
                  style={{
                    background: `${
                      selectedDept?.deptCode !== 77777 ? "#d5cce8" : "unset"
                    }`
                  }}
                  onClick={() => {
                    if (selectedDept?.deptCode !== 77777) return;
                    setShowAccount(true);
                  }}
                >
                  추가
                </Button>
                &nbsp;&nbsp;
                <Button
                  className={Styles.buttonSmallStyle}
                  style={{
                    background: `${
                      userList.filter(user => user.checked).length === 0
                        ? "#d5cce8"
                        : "unset"
                    }`
                  }}
                  onClick={() => {
                    if (userList.filter(user => user.checked).length === 0)
                      return;
                    setShowAsk(true);
                  }}
                >
                  삭제
                </Button>
              </div>
            </div>

            <div className={Styles.treeContainerStyle}>
              <OrgList
                title="조직도"
                onClick={dept => {
                  setSearchName("");
                  handleOrgDeptSelected(dept);
                }}
                onInit={handleOrgOnInit}
              />
            </div>

            <div className={Styles.listContainerStyle}>
              <div className={Styles.subTitleInnerStyle}>
                {deptName} {deptUserCount}
                <div
                  style={{
                    display: "inline-flex",
                    float: "right",
                    marginRight: "32px",
                    marginTop: "-4px"
                  }}
                >
                  {/* &nbsp;&nbsp;
                  <Button
                    className={Styles.buttonSmallStyle}
                    style={{
                      background: `${
                        userList.filter(user => user.checked).length === 0
                          ? "#d5cce8"
                          : "unset"
                      }`
                    }}
                    onClick={() => {
                      if (userList.filter(user => user.checked).length === 0)
                        return;

                      setShowOrgList(true);
                    }}
                  >
                    이동
                  </Button>
                  &nbsp;&nbsp;
                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      handlePressDelete();
                      setShowToast(true);
                    }}
                  >
                    복사
                  </Button> */}

                  <input
                    className={Styles.inputStyle}
                    placeholder="조직원을 검색하세요."
                    style={{
                      width: "200px",
                      height: "28px",
                      marginRight: "12px"
                    }}
                    value={searchName}
                    onChange={e => {
                      setSearchName(e.target.value);
                    }}
                    onSubmit={() => {
                      handlePressSearch();
                    }}
                  />

                  <Button
                    className={Styles.buttonSmallStyle}
                    onClick={() => {
                      handlePressSearch();
                    }}
                  >
                    검색
                  </Button>
                </div>
              </div>
              <div className={Styles.headerRowStyle}>
                <div className={Styles.headerCheckboxStyle}>
                  <FormControlLabel
                    style={{ marginLeft: "unset" }}
                    control={
                      <Checkbox
                        disabled={selectedDept?.deptCode !== 77777}
                        checked={allChecked}
                        onChange={e => {
                          console.log("XXX", e);
                          setAllChecked(!allChecked);
                          userList.map(user => (user.checked = !allChecked));
                          setRefresh(!refresh);
                        }}
                        value="true"
                        inputProps={{
                          "aria-label": "primary checkbox"
                        }}
                      />
                    }
                  />
                </div>
                <div className={Styles.headerColStyle}>아이디</div>
                <div className={Styles.headerColStyle}>이름</div>
                <div className={Styles.headerColStyle}>상태</div>
                <div className={Styles.headerColStyle}>그룹</div>
                <div className={Styles.headerColStyle}>메일 할당량</div>
                {/* <div className={Styles.headerColStyle}>파일 할당량</div> */}
                <div className={Styles.headerColStyle}>등록일</div>
                <div className={Styles.headerColStyle}>수정</div>
              </div>

              <div
                style={{
                  height: "calc(640px - 44px)",
                  overflowY: "scroll"
                }}
              >
                {userList.map(user => (
                  <div className={Styles.dataRowStyle} key={uuidv4()}>
                    <div className={Styles.dataCheckboxStyle}>
                      <FormControlLabel
                        style={{ marginLeft: "unset" }}
                        control={
                          <Checkbox
                            disabled={selectedDept?.deptCode !== 77777}
                            checked={user.checked}
                            onChange={e => {
                              user.checked = !user.checked;
                              console.log("XXX", user.checked);
                              setRefresh(!refresh);
                            }}
                            value="true"
                            inputProps={{
                              "aria-label": "primary checkbox"
                            }}
                          />
                        }
                      />
                    </div>
                    <div className={Styles.dataColStyle}>{user.userId}</div>
                    <div className={Styles.dataColStyle}>{user.name}</div>
                    <div className={Styles.dataColStyle}>{user.status}</div>
                    <div className={Styles.dataColStyle}>{user.groupName}</div>
                    <div className={Styles.dataColStyle}>{user.mailQuota}</div>
                    {/* <div className={Styles.dataColStyle}>{item.fileQuota}</div> */}
                    <div className={Styles.dataColStyle}>{user.date}</div>
                    <div className={Styles.dataColStyle}>
                      <Button
                        className={Styles.buttonSmallStyle}
                        onClick={() => {
                          // setShowAccount(true);
                          handlePressModifyAccount(user);
                        }}
                      >
                        수정
                      </Button>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Dialog
        open={showAsk}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"삭제"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            선택한 항목을 삭제하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setShowAsk(false);
              setShowToast(true);
            }}
          >
            아니오
          </Button>
          <Button
            color="primary"
            autoFocus
            onClick={() => {
              processPressDelete();
            }}
          >
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAskMove}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"삭제"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            선택한 구성원을 {tempDeptName} 부서로 이동하시겠습니까?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            color="primary"
            onClick={() => {
              setShowAskMove(false);
              setShowToast(true);
            }}
          >
            아니오
          </Button>
          <Button
            color="primary"
            autoFocus
            onClick={() => {
              setShowAskMove(false);
            }}
          >
            예
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showNew}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{editTitle}</DialogTitle>
        <DialogContent>
          {/* <DialogContentText id="alert-dialog-description">
            선택한 항목을 삭제하시겠습니까?
          </DialogContentText> */}
          <div>
            <div style={{ display: "inline-flex", width: "50px" }}>
              IP <span style={{ color: "red" }}>&nbsp;&nbsp;*</span>
            </div>
            <input
              type="text"
              value={editIP}
              className={Styles.inputStyle}
              onChange={e => {
                console.log("IP", e.target.value);
                setEditIP(e.target.value);
              }}
            ></input>
          </div>
          <div style={{ marginTop: "12px" }}>
            <div style={{ display: "inline-flex", width: "50px" }}>비고</div>
            <input
              type="text"
              value={editDesc}
              className={Styles.inputStyle}
              name="phone"
              onChange={e => {
                console.log("DESC", e.target.value);
                setEditDesc(e.target.value);
              }}
            ></input>
          </div>
        </DialogContent>
        <DialogActions>
          <div
            style={{ width: "100%", textAlign: "center", paddingBottom: "8px" }}
          >
            <Button
              className={Styles.buttonSmallStyle}
              onClick={() => {
                // setShowNew(false);
              }}
            >
              취소
            </Button>
            <Button
              style={{ marginLeft: "24px" }}
              className={[
                Styles.buttonSmallStyle,
                !checkIpAddress() && Styles.buttonDisableStyle
              ]}
              autoFocus
              onClick={() => {
                setShowNew(false);
              }}
            >
              저장
            </Button>
          </div>
        </DialogActions>
      </Dialog>

      <Dialog
        open={showAccount}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <AccountEdit
          mode={editMode}
          userData={editUserData}
          onCancel={() => setShowAccount(false)}
          onApply={() => {
            setShowAccount(false);

            handleOrgDeptSelected(selectedDept);
          }}
        />
      </Dialog>

      <Dialog
        open={showOrgList}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div
          style={{
            width: "400px"
          }}
        >
          <OrgList
            title="조직도"
            useAnonymous={true}
            onClick={dept => {
              setTempDeptName(dept.deptName);
            }}
          />
        </div>
        <DialogActions>
          <div
            style={{
              width: "100%",
              textAlign: "center",
              paddingBottom: "8px"
            }}
          >
            <Button
              className={Styles.buttonSmallStyle}
              onClick={() => {
                setShowOrgList(false);
              }}
            >
              취소
            </Button>
            <Button
              style={{ marginLeft: "24px" }}
              className={[Styles.buttonSmallStyle]}
              autoFocus
              onClick={() => {
                // setDeptName(tempDeptName);
                setRefresh(!refresh);
                setShowOrgList(false);
                setShowAskMove(true);
              }}
            >
              저장
            </Button>
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
}
